export const ArrowIcon = ({ ...props }) => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.940674 7.94063C0.354736 8.52657 0.354736 9.47813 0.940674 10.0641L8.44067 17.5641C9.02661 18.15 9.97817 18.15 10.5641 17.5641C11.15 16.9781 11.15 16.0266 10.5641 15.4406L4.12349 9.00001L10.5594 2.55938C11.1454 1.97344 11.1454 1.02188 10.5594 0.435944C9.97349 -0.149994 9.02192 -0.149994 8.43599 0.435944L0.935986 7.93594L0.940674 7.94063Z"
      fill="#ACACAC"
    />
  </svg>
);
